import {
    GET_DICTIONARY_COMPANY_BRANCHES_ERROR,
    GET_DICTIONARY_COMPANY_BRANCHES_REQUEST,
    GET_DICTIONARY_COMPANY_BRANCHES_SUCCESS
} from "../constants/dictionaryCompanyBranches";
import {IDictionary} from "../../models/Dictionary";
import {IActionDictionaryCompanyBranches} from "../actions/dictionaryCompanyBranches";



export interface IDictionaryCompaniesState {
    loading: boolean
    error: string
    data: IDictionary[]
}

const initialState: IDictionaryCompaniesState = {
    data: [],
    loading: false,
    error: ''
};

export default function dictionaryCompanyBranches(state = initialState, action: IActionDictionaryCompanyBranches): IDictionaryCompaniesState {
    switch (action.type) {
        case GET_DICTIONARY_COMPANY_BRANCHES_REQUEST:
            return {
                data: [],
                loading: true,
                error: ''
            };
        case GET_DICTIONARY_COMPANY_BRANCHES_SUCCESS:
            return {
                data: action.payload,
                loading: false,
                error: ''
            };
        case GET_DICTIONARY_COMPANY_BRANCHES_ERROR:
            return {
                data: [],
                loading: false,
                error: action.payload
            };
        default:
            return state;
    }
}
